import { createSlice } from "@reduxjs/toolkit";
import { fetchProjectManagerManpower } from "./thunk";

interface PRState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: PRState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const ProjectManagerManpowerSlice = createSlice({
  name: "ProjectManagerManpower",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectManagerManpower.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectManagerManpower.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProjectManagerManpower.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch fetch ProjectManager Manpower  List";
      });
  },
});

export default ProjectManagerManpowerSlice.reducer;
